<template>
  <div>
    <el-date-picker
      v-if="renderComponent"
      v-model="localValue"
      :class="`required-value-${id}`"
      class="shadow-sm"
      type="date"
      value-format="yyyy-MM-dd"
      :placeholder="`${$t('common_words.select2')}...`"
    >
    </el-date-picker>
    <p v-show="showError" class="mt-2 text-muted text-danger">
      {{ messageError }}
    </p>
  </div>
</template>
<script>
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinVModel from 'src/util/mixinVModel';
import mixinMasters from 'src/util/mixinMasters.js';

export default {
  name: 'DateCapture',
  props: {
    value: {
      default: new Date().toString(),
    },
  },
  mixins: [mixinVModel, MixinDatePicker, mixinMasters],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
};
</script>
